module.exports = __webpack_public_path__ + "img/sv73on.85a73b80.svg";